/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MPIBaseService } from '../mpi-base-service';
import { MPIApiConfiguration } from '../mpi-api-configuration';
import { MPIStrictHttpResponse } from '../mpi-strict-http-response';

import { CoidClaimManagerDto } from '../models/coid-claim-manager-dto';
import { coidClaimManagersElixirLiveGet } from '../fn/data/coid-claim-managers-elixir-live-get';
import { CoidClaimManagersElixirLiveGet$Params } from '../fn/data/coid-claim-managers-elixir-live-get';
import { InsurerDto } from '../models/insurer-dto';
import { insurersElixirLiveGet } from '../fn/data/insurers-elixir-live-get';
import { InsurersElixirLiveGet$Params } from '../fn/data/insurers-elixir-live-get';
import { MedicalSchemeDto } from '../models/medical-scheme-dto';
import { medicalSchemesElixirLiveGet } from '../fn/data/medical-schemes-elixir-live-get';
import { MedicalSchemesElixirLiveGet$Params } from '../fn/data/medical-schemes-elixir-live-get';

@Injectable({ providedIn: 'root' })
export class MPIDataService extends MPIBaseService {
  constructor(config: MPIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `medicalSchemesElixirLiveGet()` */
  static readonly MedicalSchemesElixirLiveGetPath = '/MedicalSchemes/ElixirLive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalSchemesElixirLiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicalSchemesElixirLiveGet$Response(params?: MedicalSchemesElixirLiveGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<Array<MedicalSchemeDto>>> {
    return medicalSchemesElixirLiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalSchemesElixirLiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicalSchemesElixirLiveGet(params?: MedicalSchemesElixirLiveGet$Params, context?: HttpContext): Observable<Array<MedicalSchemeDto>> {
    return this.medicalSchemesElixirLiveGet$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<Array<MedicalSchemeDto>>): Array<MedicalSchemeDto> => r.body)
    );
  }

  /** Path part for operation `insurersElixirLiveGet()` */
  static readonly InsurersElixirLiveGetPath = '/Insurers/ElixirLive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insurersElixirLiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  insurersElixirLiveGet$Response(params?: InsurersElixirLiveGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<Array<InsurerDto>>> {
    return insurersElixirLiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insurersElixirLiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  insurersElixirLiveGet(params?: InsurersElixirLiveGet$Params, context?: HttpContext): Observable<Array<InsurerDto>> {
    return this.insurersElixirLiveGet$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<Array<InsurerDto>>): Array<InsurerDto> => r.body)
    );
  }

  /** Path part for operation `coidClaimManagersElixirLiveGet()` */
  static readonly CoidClaimManagersElixirLiveGetPath = '/CoidClaimManagers/ElixirLive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `coidClaimManagersElixirLiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  coidClaimManagersElixirLiveGet$Response(params?: CoidClaimManagersElixirLiveGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<Array<CoidClaimManagerDto>>> {
    return coidClaimManagersElixirLiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `coidClaimManagersElixirLiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  coidClaimManagersElixirLiveGet(params?: CoidClaimManagersElixirLiveGet$Params, context?: HttpContext): Observable<Array<CoidClaimManagerDto>> {
    return this.coidClaimManagersElixirLiveGet$Response(params, context).pipe(
      map((r: MPIStrictHttpResponse<Array<CoidClaimManagerDto>>): Array<CoidClaimManagerDto> => r.body)
    );
  }

}
